import { SettlementCreateForm } from '../components';

export const SettlementRegisterSection = () => <SettlementCreateForm />;
